module.exports = __webpack_public_path__ + "static/media/Power_Supply_Leads.54f83627.svg";